import { guests } from 'api';
import { ThunkAction } from 'store/types';

export const UPDATE_GUEST_VIRTUAL_BACKGROUND = 'UPDATE_GUEST_VIRTUAL_BACKGROUND';
export const REMOVE_GUEST_VIRTUAL_BACKGROUND = 'REMOVE_GUEST_VIRTUAL_BACKGROUND';

export const fetchGuestVirtualBackground =
  (authToken: string): ThunkAction =>
  async dispatch => {
    try {
      const { data } = await guests().clientMeetingRooms().getVirtualBackground(authToken);

      dispatch({
        type: UPDATE_GUEST_VIRTUAL_BACKGROUND,
        payload: { virtualBackground: data?.url },
      });
    } catch {}
  };

export const updateGuestVirtualBackground =
  (virtualBackground: string): ThunkAction =>
  async dispatch => {
    dispatch({
      type: UPDATE_GUEST_VIRTUAL_BACKGROUND,
      payload: { virtualBackground },
    });
  };

export const removeGuestVirtualBackground = (): ThunkAction => async dispatch => {
  dispatch({ type: REMOVE_GUEST_VIRTUAL_BACKGROUND });
};
